'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _noop2 = require('lodash/noop');

var _noop3 = _interopRequireDefault(_noop2);

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactI18next = require('react-i18next');

var _reactRedux = require('react-redux');

var _quicksend = require('redux/modules/quicksend');

var quicksendActions = _interopRequireWildcard(_quicksend);

var _project = require('redux/modules/project');

var projectActions = _interopRequireWildcard(_project);

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _reduxForm = require('redux-form');

var _quickSendFormValidation = require('./quickSendFormValidation');

var _quickSendFormValidation2 = _interopRequireDefault(_quickSendFormValidation);

var _Button = require('../Button/Button');

var _Button2 = _interopRequireDefault(_Button);

var _EmailField = require('./form/EmailField');

var _EmailField2 = _interopRequireDefault(_EmailField);

var _SubjectRow = require('./form/SubjectRow');

var _SubjectRow2 = _interopRequireDefault(_SubjectRow);

var _MessageRow = require('./form/MessageRow');

var _MessageRow2 = _interopRequireDefault(_MessageRow);

var _ExpireDateRow = require('./form/ExpireDateRow');

var _ExpireDateRow2 = _interopRequireDefault(_ExpireDateRow);

var _WatermarkField = require('./form/WatermarkField');

var _WatermarkField2 = _interopRequireDefault(_WatermarkField);

var _DownloadField = require('./form/DownloadField');

var _DownloadField2 = _interopRequireDefault(_DownloadField);

var _projects = require('selectors/projects');

var _forms = require('helpers/forms');

var _QuickSendTracklist = require('./QuickSendTracklist');

var _QuickSendTracklist2 = _interopRequireDefault(_QuickSendTracklist);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./QuickSendForwardForm.scss');

var formDefaults = {
  subject: '',
  message: '',
  expiryDate: '',
  directAccessWatermark: false,
  fwd: false,
  download: false
};

var QuickSendForwardForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    recipientsList: (0, _projects.getRecipients)(state)
  };
}, (0, _extends3.default)({}, quicksendActions, projectActions)), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'quickSendForwardForm',
  propNamespace: 'quickSendForwardForm',
  initialValues: formDefaults,
  validate: _quickSendFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(QuickSendForwardForm, _Component);

  function QuickSendForwardForm() {
    (0, _classCallCheck3.default)(this, QuickSendForwardForm);
    return (0, _possibleConstructorReturn3.default)(this, (QuickSendForwardForm.__proto__ || (0, _getPrototypeOf2.default)(QuickSendForwardForm)).apply(this, arguments));
  }

  (0, _createClass3.default)(QuickSendForwardForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          data = _props.data,
          clearRecipientsList = _props.clearRecipientsList,
          initialize = _props.quickSendForwardForm.initialize;

      clearRecipientsList();
      var directAccessWatermark = data.directAccessWatermark,
          expiryDate = data.expiryDate,
          recipients = data.recipients,
          subject = data.subject,
          message = data.message;

      var download = (0, _get3.default)(recipients, [0, 'download']);
      initialize({ subject: subject, message: message, directAccessWatermark: directAccessWatermark, fwd: false, expiryDate: expiryDate, download: download });
    }
  }, {
    key: 'publish',
    value: function publish() {
      var _props2 = this.props,
          publish = _props2.publish,
          id = _props2.id;

      return publish(id).promise;
    }
  }, {
    key: 'submit',
    value: function submit(formData) {
      var _props3 = this.props,
          qsSave = _props3.qsSave,
          id = _props3.id,
          onForward = _props3.onForward;

      return qsSave((0, _forms.normalizeFormData)((0, _extends3.default)({}, formData, { projectId: id }))).promise.then(this.publish).then(onForward).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props4 = this.props,
          id = _props4.id,
          t = _props4.t,
          data = _props4.data,
          recipientsList = _props4.recipientsList,
          _props4$quickSendForw = _props4.quickSendForwardForm,
          handleSubmit = _props4$quickSendForw.handleSubmit,
          submitting = _props4$quickSendForw.submitting,
          invalid = _props4$quickSendForw.invalid;

      var isSubmitDisabled = invalid || submitting || !recipientsList.length;

      return _react2.default.createElement(
        'div',
        { className: styles.form },
        _react2.default.createElement(_EmailField2.default, { projectId: id }),
        _react2.default.createElement(
          'form',
          { onSubmit: handleSubmit(this.submit) },
          _react2.default.createElement(_SubjectRow2.default, null),
          _react2.default.createElement(_MessageRow2.default, null),
          _react2.default.createElement(_ExpireDateRow2.default, { inputProps: { className: 'material' } }),
          _react2.default.createElement(
            'div',
            { className: 'margin-top-20' },
            _react2.default.createElement(_WatermarkField2.default, { className: 'margin-right-20' }),
            _react2.default.createElement(_DownloadField2.default, null)
          ),
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              'h3',
              null,
              t('Tracklist')
            ),
            _react2.default.createElement(_QuickSendTracklist2.default, {
              className: styles.trackList,
              tracks: data.tracks,
              album: data,
              playable: false
            })
          ),
          _react2.default.createElement(
            'div',
            { className: 'text-right' },
            _react2.default.createElement(
              _Button2.default,
              {
                type: 'submit',
                className: 'btn-default',
                disabled: isSubmitDisabled,
                loading: submitting
              },
              t('Send')
            )
          )
        )
      );
    }
  }]);
  return QuickSendForwardForm;
}(_react.Component), _class3.propTypes = {
  clearRecipientsList: _propTypes2.default.func,
  data: _propTypes2.default.object,
  id: _propTypes2.default.number,
  onForward: _propTypes2.default.func,
  publish: _propTypes2.default.func,
  qsSave: _propTypes2.default.func,
  quickSendForwardForm: _propTypes2.default.object,
  recipientsList: _propTypes2.default.array,
  t: _propTypes2.default.func
}, _class3.defaultProps = {
  data: { tracks: [] },
  onForward: _noop3.default,
  quickSendForwardForm: {},
  recipientsList: []
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'publish', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'publish'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = QuickSendForwardForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/QuickSend/QuickSendForwardForm.js
// module id = 2073
// module chunks = 1